import { observer } from 'mobx-react-lite';
import { PopulatedExperienceTag } from '@/schemas/experience-tag-schema.ts';
import experienceTagStore from '@store/experience-tag-store.ts';
import Button from '@components/core/button/button.tsx';
import { ScreenBreakpoint } from '@/enums/screen-breakpoints.ts';
import { IconEnum } from '@components/core/icon/icon-enum.ts';
import modalStore from '@store/modal-store.ts';
import PlaceTagDetailsAdd from '@views/experience-tag-details/view-components/experience-tag-details-add.tsx';
import useScreenBreakpoint from '@hooks/use-screen-breakpoint.tsx';
import ClassString from '@utils/class-string.ts';
import experienceStatsStore from '@store/experience-stats-store.ts';
import averagePlaytimeStatsStore from '@store/experience-stats/average-playtime-stats-store.ts';

interface ExperienceTagDetailsAddButtonProps {
	tag: PopulatedExperienceTag;
}

const ExperienceTagDetailsAddButton = observer(
	function ExperienceTagDetailsAddButton(
		props: ExperienceTagDetailsAddButtonProps
	) {
		const screenBreakpoint = useScreenBreakpoint();

		const addExperienceToTag = async (ids: number[]) => {
			const experienceList = props.tag.places.map(
				(place) => place.place_id
			);
			experienceList?.push(...ids);
			await experienceTagStore.updateExperienceTag(props.tag.id, {
				...props.tag,
				place_ids: experienceList,
			});
			experienceStatsStore.clearTagCCU(props.tag);
			averagePlaytimeStatsStore.clearTagPlaytime(props.tag.id);
		};

		return (
			<Button
				title={
					screenBreakpoint <= ScreenBreakpoint.SM
						? 'Add'
						: 'Add Experiences'
				}
				icon={{
					icon: IconEnum.ADD,
					placement: 'right',
				}}
				className={ClassString({
					static: 'mx-4',
					dynamic: {
						'animate-pulse-ring hover:animate-none':
							!props.tag.places.length && !modalStore.visible,
					},
				})}
				onClick={() =>
					modalStore.open(
						<PlaceTagDetailsAdd
							tagName={props.tag.name ?? ''}
							submit={addExperienceToTag}
						/>,
						{ overflow: true }
					)
				}
			/>
		);
	}
);

export default ExperienceTagDetailsAddButton;
